if($('.type-category').length){
    $(document).ready(function() {
        if(!$('#category-header .openFormSearch').length){
            $('#category-header').append('<span class="openFormSearch">Seřadit dle</span>');
        }
    });
    document.addEventListener('ShoptetDOMContentLoaded', function() {
        if(!$('#category-header .openFormSearch').length){
            $('#category-header').append('<span class="openFormSearch">Seřadit dle</span>');
        }
    });
    document.addEventListener('ShoptetDOMPageContentLoaded', function() {
        if(!$('#category-header .openFormSearch').length){
            $('#category-header').append('<span class="openFormSearch">Seřadit dle</span>');
        }
    });    
    $('html').on('click', '.openFormSearch', function(){
        $(this).closest('#category-header').find('form').toggleClass('openForm')
    })    
}

if ($('.subcategories').length) {
    $('.subcategories > li').each(function () {
        var img = $(this).find('img');
        var dataSrc = img.attr('data-src');
        if (dataSrc && !dataSrc.includes('folder.svg')) {
            // nahraď pouze, pokud to není folder.svg
            var newSrc = dataSrc.replace('/thumb/', '/orig/');
            img.attr('src', newSrc);
            img.attr('data-src', newSrc);
        }
    });
}